import { sendReq } from '@/utils/request'

/**
 * 按钮权限指令
 * app.directive("has", );
 */
export const d_has = {
  bind: function(el, binding, vnode) {
      let id = "",
          isCommonAuth = false, //通用权限（多个页面同时使用的权限）
          name = binding.arg;
      if (!name) {
          if (binding.value instanceof Object) {
              name = binding.value.name;
              isCommonAuth = binding.value.isCommonAuth;
          } else {
              name = binding.value;
          }
      }

      //普通权限通过路由中的id去对比（每个页面中的按钮权限）
      if (!isCommonAuth) {
          if(!vnode?.context?.$route?.meta?.operation?.forEach) return;
          vnode.context.$route.meta.operation.forEach(item => {
              if (name == item.name) {
                  id = item.id;
              }
          });
      } else {
          id = name;
      }

      if (!Vue.prototype.$_has(id, isCommonAuth)) {
          vnode.context.$nextTick(() => {
            if (el && el.parentNode) el.parentNode.removeChild(el);
          });
      }
  }
}


/**
 * @Description: 文件下载，请求添加token指令
 * binding.value 必须包含两个属性  fileUrl和fileName
 * app.directive("fileDownload", );
 */
export const d_fileDownload = {
    bind(el, binding, vnode) {
        //只有当发生click事件时才去执行下载
        el.addEventListener('click', function (e) {
          e.stopPropagation();
          d_fileDownload.requestHref(binding.value);
        })
    },
    //附件下载
    async requestHref(item) {
        var url = location.origin + '/' + item.fileUrl;
        //获取文件流
        let blob = await sendReq({url, responseType: 'blob'});
        if(blob){
            //创键临时url对象
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = item.fileName;
            a.click();
            //释放之前创建的URL对象
            window.URL.revokeObjectURL(url);
        }
    }
}

  
/**
 * 请求认证视频图片
 * app.directive("imgPreview", );
 */
export const d_imgPreview = {
    bind(el, binding, vnode) {
        d_imgPreview.requestImage(binding.value, el, vnode.context);
    },
    /* update(el, binding, vnode) {
        //解决图片轮播切换的变更问题
        if (binding.value != binding.oldValue) {
            this.requestImage(binding.value, el, vnode.context);
        }
    }, */
    async requestImage(fileUrl, element, that) {
        if(!fileUrl) return;
        let url = location.origin + '/uploadApi/' + fileUrl;
        //获取文件流
        let blob = await sendReq({url, responseType: 'blob'});
        element.onload = function (e) {
          window.URL.revokeObjectURL(element.src);
        };
        element.src = window.URL.createObjectURL(blob);
    }
}

/* 
  防抖

*/
export const d_debounce = {
  bind(el, binding) {
      let timeout
      const delay = parseInt(binding.arg) || 800 // 获取延迟时间，默认为800毫秒
  
      el.addEventListener('input', () => {
        clearTimeout(timeout) // 每次触发输入事件前清除之前的定时器
        timeout = setTimeout(() => {
          binding.value() // 执行绑定的函数
        }, delay)
      })
    }
}

